import { UserAvatar } from "@/components/ui/stacked-avatars";
import { FireIcon } from "./fire-icon";
import { PeriwinkleCard } from "./periwinkle-card";

interface ConnectSummaryThumbnailProps {
  ownerName: string;
  ownerAvatarUrl: string | undefined;
  teenName: string;
  teenAvatarUrl: string | undefined;
  size?: "sm" | "md";
}

const SIZES = {
  sm: {
    card: "h-12 w-12 flex-shrink-0 rounded-md",
    avatar: 16,
    overlap: -6,
    fire: 10,
    fireGap: "gap-0.5",
  },
  md: {
    card: "h-20 w-20 flex-shrink-0 rounded-lg",
    avatar: 26,
    overlap: -10,
    fire: 12,
    fireGap: "gap-1",
  },
} as const;

export function ConnectSummaryThumbnail({
  ownerName,
  ownerAvatarUrl,
  teenName,
  teenAvatarUrl,
  size = "sm",
}: ConnectSummaryThumbnailProps) {
  const s = SIZES[size];
  return (
    <PeriwinkleCard variant="highlight" className={s.card}>
      <div className="flex h-full flex-col items-center justify-center gap-1.5">
        <div className="flex flex-row items-center justify-center">
          <UserAvatar
            imageUrl={ownerAvatarUrl}
            name={ownerName}
            size={s.avatar}
            showBorder
          />
          <div style={{ marginLeft: s.overlap }}>
            <UserAvatar
              imageUrl={teenAvatarUrl}
              name={teenName}
              size={s.avatar}
              showBorder
            />
          </div>
        </div>
        <div className={`flex flex-row items-center ${s.fireGap}`}>
          {[0, 1, 2].map((i) => (
            <FireIcon key={i} size={s.fire} />
          ))}
        </div>
      </div>
    </PeriwinkleCard>
  );
}
